<script lang="ts">
  import {onMount} from 'svelte';
  import type {Survey} from './types';
  import SurveyComponent from './Survey.svelte';
  import surveyIndex from './surveys/survey-index';
  import Admin from './Admin.svelte';

  let survey: Survey | null;
  let admin: string | false = false;
  const updatePage = async () => {
    const href = location.href;
    if (!href.includes('#')) {
      survey = null;
      return;
    }
    const route = href.split('#')[1].split('/').slice(1);
    const targetName = route[0];
    if (targetName === 'admin') {
      admin = route[1];
      return;
    }
    survey = surveyIndex[targetName] || null;
  };
  window.onhashchange = updatePage;
  onMount(() => updatePage());
</script>

{#if !admin && survey}
  <SurveyComponent {survey} />
{/if}

{#if admin}
  <Admin survey={admin} />
{/if}

{#if !survey && !admin}
  <h1>Survey not found</h1>
{/if}

<style lang="postcss" global>
  @tailwind base;
  @tailwind components;
  @tailwind utilities;
</style>
